import jsPDF from "jspdf";
import "jspdf-autotable";
import { UserOptions } from "jspdf-autotable";
import moment from "moment";
import AuthService from "../../services/auth/AuthService";

export interface jsPDFWithPlugin extends jsPDF {
    autoTable: (options: UserOptions) => jsPDF;
}

abstract class DownloadTable {
    protected title: string;
    protected filters: string[];

    protected TABLE_START_Y = 45;
    protected readonly TEXT_START_X = 14;
    protected readonly TEXT_START_Y = 16;
    protected readonly DEFAULT_FONT_SIZE = 12;
    protected readonly TITLE_FONT_SIZE = 18;
    protected readonly TABLE_BOTTOM_MARGIN = 35;
    protected readonly FILTERS_MARGIN = 5;
    protected readonly TITLE_COLOR = "#1a77d2";
    protected readonly TEXT_COLOR = "#000000";

    constructor(title: string, filters: string[]) {
        this.title = title;
        this.filters = filters;
    }

    protected addHeader(pdf: jsPDFWithPlugin) {
        const pageWidth = pdf.internal.pageSize.getWidth();
        const titleStartX =
            (pageWidth -
                (pdf.getStringUnitWidth(this.title) * pdf.getFontSize()) /
                    pdf.internal.scaleFactor) /
            2;
        pdf.text(this.title, titleStartX, this.TEXT_START_Y);
    }

    protected addFooter(
        pdf: jsPDFWithPlugin,
        userLabel: string,
        dateLabel: string
    ) {
        pdf.setFontSize(this.DEFAULT_FONT_SIZE);
        pdf.setTextColor(this.TEXT_COLOR);
        const pageCount = pdf.internal.pages.length - 1;

        for (let i = 1; i <= pageCount; i++) {
            pdf.setPage(i);

            const user = `${userLabel}: ${AuthService.user?.name}`;
            const exportDate = `${dateLabel}: ${moment().utc().local().format("LLL")}`;
            const pagination = `${i}/${pageCount}`;

            const pageWidth = pdf.internal.pageSize.getWidth();

            // Left aligned text
            pdf.text(
                user,
                this.TEXT_START_X,
                pdf.internal.pageSize.getHeight() - this.TEXT_START_X * 1.5
            );
            pdf.text(
                exportDate,
                this.TEXT_START_X,
                pdf.internal.pageSize.getHeight() - this.TEXT_START_X
            );

            // Right aligned text
            const textWidth =
                (pdf.getStringUnitWidth(pagination) * pdf.getFontSize()) /
                pdf.internal.scaleFactor;
            pdf.text(
                pagination,
                pageWidth - textWidth - this.TEXT_START_X,
                pdf.internal.pageSize.getHeight() - this.TEXT_START_X
            );
        }
    }
    protected addFilters(pdf: jsPDFWithPlugin) {
        pdf.setTextColor(this.TEXT_COLOR);
        pdf.setFontSize(this.DEFAULT_FONT_SIZE);

        const pageWidth = pdf.internal.pageSize.getWidth();
        const marginX = 10;
        const maxWidth = pageWidth - 2 * marginX;

        let currentY = this.TEXT_START_Y * 1.3 + this.FILTERS_MARGIN;

        this.filters.forEach((filter) => {
            filter = filter.replace("✓", "'");

            const lines = pdf.splitTextToSize(filter, maxWidth);

            lines.forEach((line: any) => {
                const textWidth =
                    (pdf.getStringUnitWidth(line) * pdf.getFontSize()) /
                    pdf.internal.scaleFactor;
                const textStartX = (pageWidth - textWidth) / 2;

                pdf.text(line, textStartX, currentY);
                currentY += this.FILTERS_MARGIN;
            });
        });

        this.TABLE_START_Y = currentY + this.FILTERS_MARGIN;
    }
}

export default DownloadTable;
